/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Component, Input} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {JsonPipe, NgIf} from "@angular/common";

@Component({
  selector: 'app-fields-errors',
  standalone: true,
  imports: [
    FaIconComponent,
    JsonPipe,
    NgIf
  ],
  templateUrl: './fields-errors.component.html',
  styleUrl: './fields-errors.component.scss'
})
export class FieldsErrorsComponent {
  @Input("errors") errors: any;
}
